// extracted by mini-css-extract-plugin
export var cardHeader = "_ib-1";
export var contentCard = "_ib-0";
export var headerActions = "_ib-3";
export var reorderHandle = "_ib-5";
export var titleArea = "_ib-2";
export var titleAreaWithHandle = "_ib-4";